import _regeneratorRuntime from "/data/maven/.jenkins/workspace/web/web/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { agentClaim_queryPage, getExcelPath, download, agentClaim_import, saveBcAgentClaim, deleteBcAgentClaim } from '@/api/baseDataManage';
import { getCompanyList } from '@/api/baseDate';
import { getCon, getCountryList, getCityList, getChildCountry, getUnderCity, getCHNCity } from '@/utils/country';
export default {
  name: 'AgentClaim',
  data: function data() {
    var testEmail = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(rule, item, callback) {
        var re;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/g;

                if (!item) {
                  _context.next = 4;
                  break;
                }

                if (re.test(item)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", callback(new Error('电子邮箱格式不正确')));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function testEmail(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    var emailValidator = function emailValidator(rule, value, callback) {
      if (value) {
        var valueList = value.split(",");
        valueList.map(function (item) {
          testEmail(rule, item, callback);
        });
        callback();
      } else {
        callback();
      }
    };

    return {
      areas: [],
      countrys: [],
      citys: [],
      countryList: [],
      cityList: [],
      cityArr: [],
      fileList: [],
      company: '',
      // 保险公司
      companyList: [],
      // 获取保险公司列表并匹配
      // 查询条件
      form: {
        insuranceCompanyCode: '',
        countryCode: '',
        agentCode: '',
        cityCode: '',
        city: '',
        pageNo: 1,
        pageSize: 10
      },
      claimId: '',
      total: 0,
      // 数据条数
      // 列表数据
      tableData: [],
      loading: false,
      screenLoading: null,
      newumarBtn: false,
      new_edit: false,
      editData: {},
      markForm: {
        type: '1',
        address: '',
        agentCode: '',
        agentName: '',
        area: '',
        areaCode: '',
        city: '',
        cityCode: '',
        claimId: '',
        country: '',
        countryCode: '',
        email: '',
        facsimileNumber: '',
        insuranceCompanyCode: '',
        insuranceCompanyName: '',
        remarks: '',
        telephoneNumber: '',
        areaEname: '',
        cityEname: '',
        countryEname: ''
      },
      markForm_new: {
        type: '0',
        address: '',
        agentCode: '',
        agentName: '',
        area: '',
        areaEname: '',
        areaCode: '',
        city: '',
        cityEname: '',
        cityCode: '',
        claimId: '',
        country: '',
        countryEname: '',
        countryCode: '',
        email: '',
        facsimileNumber: '',
        insuranceCompanyCode: '',
        insuranceCompanyName: '',
        remarks: '',
        telephoneNumber: ''
      },
      countryrule: {
        countryCode: [{
          required: true,
          message: '请输入国家 / 地区名称',
          trigger: 'change'
        }],
        areaCode: [{
          required: true,
          message: '请输入大洲名称',
          trigger: 'change'
        }],
        city: [{
          required: true,
          message: '请输入城市名称',
          trigger: 'change'
        }],
        address: [{
          required: true,
          message: '请输入代理点地址',
          trigger: 'blur'
        }, {
          max: 200,
          message: '最大长度为200个字符',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: '请输入邮箱',
          trigger: 'blur'
        }, {
          max: 200,
          message: '最大长度为200个字符',
          trigger: 'blur'
        }, {
          validator: emailValidator,
          trigger: 'blur'
        } //{ pattern: /^((([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6}\,))*(([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})))$/, message: '电子邮箱格式不正确' }
        ],
        facsimileNumber: [{
          required: true,
          message: '请输入传真',
          trigger: 'blur'
        }, {
          max: 100,
          message: '最大长度为100个字符',
          trigger: 'blur'
        }],
        //remarks: [{ max: 200, message: '最大长度为200个字符', trigger: 'blur' }],
        telephoneNumber: [{
          required: true,
          message: '请输入电话',
          trigger: 'blur'
        } //{ pattern: /(\d{2,5}-\d{7,8}(-\d{1,})?)|(13\d{9})|(159\d{8})/, message: '电话格式不正确' }
        ],
        agentCode: [{
          required: true,
          message: '请输入代理点代码',
          trigger: 'blur'
        }],
        agentName: [{
          required: true,
          message: '请输入代理点名称',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    getCompanyList().then(function (res) {
      _this.companyList = Object.assign([], res); // this.company = this.form.insuranceCompanyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode

      _this.company = _this.form.insuranceCompanyCode = JSON.parse(sessionStorage.getItem('newinsurancecompanyCode'));
      _this.areas = getCon();
      _this.countrys = getCountryList(); // this.citys = getCityList()

      _this.getData();
    });
  },
  methods: {
    //   查询
    submitForm: function submitForm(formName) {
      this.form.pageNo = 1;
      this.getData();
    },
    // 获取数据
    getData: function getData() {
      var _this2 = this;

      this.loading = true;
      agentClaim_queryPage(_objectSpread({}, this.form)).then(function (res) {
        _this2.loading = false;
        _this2.total = res.totalCount;
        _this2.tableData = Object.assign([], res.content);
      });
    },
    //   重置查询条件
    resetForm: function resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.form.countryCode = '';
      this.form.agentCode = '';
      this.form.cityCode = '';
      this.form.city = '';
      this.getData();
    },
    // 分页方法
    handleSizeChange: function handleSizeChange(val) {
      this.form.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getData();
    },
    // 编辑/新增保存
    editSave: function editSave(formName, type) {
      var _this3 = this;

      var data = type == 'edit' ? this.markForm : this.markForm_new;

      if (type == 'edit') {
        this.markForm.type = '1';
      } else {
        this.markForm_new.type = '0';
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          saveBcAgentClaim(data).then(function (res) {
            if (res.resultCode == '0000') {
              _this3.$message({
                message: '保存成功',
                type: 'success'
              });

              for (var key in _this3.markForm_new) {
                _this3.markForm_new[key] = '';
              }

              _this3.newumarBtn = false;
              _this3.new_edit = false;

              _this3.getData();

              _this3.markForm_new = {
                address: '',
                agentCode: '',
                agentName: '',
                area: '',
                areaCode: '',
                city: '',
                cityCode: '',
                claimId: '',
                country: '',
                countryCode: '',
                email: '',
                facsimileNumber: '',
                insuranceCompanyCode: '',
                insuranceCompanyName: '',
                remarks: '',
                telephoneNumber: ''
              };
            } else {
              _this3.$message({
                message: res.resultMsg,
                type: 'warning'
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 编辑
    edit: function edit(data) {
      this.editData = data;
      this.countryList = getChildCountry(data.areaCode);

      if (data.countryCode == 'CHN') {
        this.cityList = getCHNCity(data.countryCode);
        console.log('this.cityList1--', this.cityList);
      } else {
        this.cityList = getUnderCity(data.countryCode);
        console.log('this.cityList2==', this.cityList);
      }

      this.new_edit = true;

      for (var key in this.markForm) {
        this.markForm[key] = data[key];
      }
    },
    // 删除
    dele: function dele(data) {
      var _this4 = this;

      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteBcAgentClaim({
          claimId: data.claimId
        }).then(function (res) {
          if (res.resultCode == '0000') {
            _this4.$message({
              type: 'success',
              message: '删除成功!'
            });

            _this4.submitForm();
          } else {
            _this4.$message({
              type: 'warning',
              message: res.resultMsg
            });
          }
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 取消
    selectcancel: function selectcancel(formname, type) {
      var _this5 = this;

      console.log('formname', formname);

      if (type == 'new') {
        this.newumarBtn = false;
      } else {
        this.new_edit = false;
      }

      this.getData();
      this.$nextTick(function () {
        _this5.$refs[formname].clearValidate();
      });
    },
    // 获取下载链接
    getExecl: function getExecl() {
      getExcelPath({
        fileDownloadType: 'claim'
      }).then(function (res) {
        if (res.rtnCode == '0000') {
          // 获取下载文件
          //YCKK-1008 修改 理赔代理点导入模板.xlsx 对应 claimAgentImportFormWork.xlsx
          download({
            fileSrc: res.fileSrc
          }).then(function (res2) {
            var blob = new Blob([res2], {
              type: 'application/vnd.ms-excel'
            }); // 兼容ie

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, '理赔代理点清单模板.xlsx');
            } else {
              var url = window.URL.createObjectURL(blob);
              var link = document.createElement('a'); // 创建a标签

              link.href = url;
              link.download = '理赔代理点清单模板.xlsx'; // 重命名文件

              link.click();
              window.URL.revokeObjectURL(url); // 释放内存
            }
          });
        }
      });
    },
    // 选择大洲
    selectArea: function selectArea(areaCode, type) {
      var _this6 = this;

      if (type == 'new') {
        this.areas.forEach(function (item) {
          if (areaCode === item.codeCode) {
            _this6.markForm_new.area = item.codeCname;
            _this6.markForm_new.areaEname = item.codeEname;
            _this6.markForm_new.countryCode = '';
            _this6.markForm_new.cityCode = '';
          }
        });
      } else {
        this.areas.forEach(function (item) {
          if (areaCode === item.codeCode) {
            _this6.markForm.area = item.codeCname;
            _this6.markForm.areaEname = item.codeEname;
            _this6.markForm.countryCode = '';
            _this6.markForm.cityCode = '';
          }
        });
      }

      this.countryList = getChildCountry(areaCode);
    },
    // 选择国家或地区
    selectCountry: function selectCountry(countryCode, type) {
      var _this7 = this;

      console.log('国家===', countryCode);

      if (type == 'new') {
        this.countrys.forEach(function (item) {
          if (countryCode === item.codeCode) {
            _this7.markForm_new.country = item.codeCname;
            _this7.markForm_new.countryEname = item.codeEname;
            _this7.markForm_new.cityCode = '';
          }
        });
      } else {
        this.countrys.forEach(function (item) {
          if (countryCode === item.codeCode) {
            _this7.markForm.country = item.codeCname;
            _this7.markForm.countryEname = item.codeEname;
            _this7.markForm.cityCode = '';
          }
        });
      }

      if (countryCode == 'CHN') {
        this.cityList = getCHNCity();
      } else {
        this.cityList = getUnderCity(countryCode);
      }
    },
    // 选择城市
    selectCity: function selectCity(cityCode, type) {
      var _this8 = this;

      console.log('cityCode--', cityCode);

      if (type == 'new') {
        this.cityList.forEach(function (item) {
          if (cityCode === item.codeCode) {
            _this8.markForm_new.city = item.codeCname;
            _this8.markForm_new.cityEname = item.codeEname;
            console.log('this.markForm.city', _this8.markForm.cityEname);
          }
        });
      } else {
        console.log('cityCode', cityCode);
        this.cityList.forEach(function (item) {
          if (cityCode === item.codeCode) {
            _this8.markForm.city = item.codeCname;
            _this8.markForm.cityEname = item.codeEname;
            console.log('this.markForm.city', _this8.markForm.cityEname);
          }
        });
      }
    },
    openFullScreen2: function openFullScreen2() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '导入中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    openFullScreen: function openFullScreen() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    // 上传
    importExcel: function importExcel(file) {
      var _this9 = this;

      var extension = file.file.name.substring(file.file.name.lastIndexOf('.') + 1);

      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message.warning('只能上传后缀是.xlsx或者.xls的文件');
        return;
      }

      var dataFile = new FormData();
      dataFile.append('file', file.file);
      this.openFullScreen2();
      agentClaim_import(dataFile).then(function (res) {
        _this9.screenLoading.close();

        if (res.resultCode == '0000') {
          _this9.$message({
            type: 'success',
            message: '导入成功'
          });

          _this9.getData();
        } else {
          _this9.$message({
            type: 'warning',
            message: res.resultMsg
          });
        }
      });
    }
  }
};